import { render, staticRenderFns } from "./CandidatosRegistra.vue?vue&type=template&id=7b55bcca&"
import script from "./CandidatosRegistra.vue?vue&type=script&lang=js&"
export * from "./CandidatosRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports